document.addEventListener("DOMContentLoaded", function () {

  function insertLocksmithText() {
    const container = document.querySelector("#locksmith-content");
    const button = container ? container.querySelector("button") : null;

    if (button && !document.querySelector(".custom-locksmith-text")) {
      
      const extraText = document.createElement("div");
      extraText.className = "custom-locksmith-text";
      extraText.innerHTML = "COSA TROVERAI Rituali stagionali - Ricette di bellezza botanica - Luoghi che ispirano Cultum - Inviti e momenti riservati - Anteprime e creazioni in arrivo - Piccole attenzione dedicate, come la spedizione sempre offerta ";
      
      button.parentNode.insertAdjacentElement("afterend", extraText);
    }
  }

  // Locksmith loads dynamically → observe DOM changes
  const observer = new MutationObserver(insertLocksmithText);
  observer.observe(document.body, { childList: true, subtree: true });

});
